import React from 'react';

import Header from './Header';
import Nav from './Nav';

export interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Nav />
      <main className="ml-60 w-[calc(100%-240px)] pt-14">{children}</main>
    </div>
  );
};

export default AuthenticatedLayout;
